import { defineRecipe } from '@react/chakra';

export const topicRecipe = defineRecipe({
  base: {
    textAlign: 'center',
    bgColor: 'gray.600',
    borderRadius: '9999px',
    transitionDuration: '.3s',
    transitionTimingFunction: 'cubic-bezier(.4, 0, .2,1)',
    transitionProperty:
      'color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter',
    _statusActive: {
      color: 'black',
      bgColor: 'white',
      _hover: {
        color: 'black',
        bgColor: 'white',
      },
    },
  },
  variants: {
    variant: {
      normal: {},
      selectable: {
        cursor: 'pointer',
        userSelect: 'none',
        _hover: {
          color: 'black',
          bgColor: 'gray.400',
        },
      },
    },
    size: {
      xl: {
        fontSize: 'xl',
        px: {
          base: 4,
          md: 8,
        },
        py: {
          base: 2,
          md: 4,
        },
      },
      xs: {
        px: 6,
        py: 1,
        fontSize: 'lg',
      },
    },
  },
  defaultVariants: {
    size: 'xl',
  },
});
